import { Component } from '@angular/core';
import { soundpostPostingGroupLineDimensionEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Posting Group Line Dimensions') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostpostinggrouplinedimension-form',
    templateUrl: './soundpostpostinggrouplinedimension.form.component.html'
})
export class soundpostPostingGroupLineDimensionFormComponent extends BaseFormComponent {
    public record!: soundpostPostingGroupLineDimensionEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

